import autoComplete from "./autoComplete.js";

const zpForm = document.getElementById( 'zp-birthreport-form' );
var cityIn = document.getElementById('placein'),
	zpSubmit = document.getElementById( 'zp-fetch-birthreport' );

var zpResultPage = document.getElementById('zp-report-wrap');
var zpResultAltLocation = document.querySelector('[data-zodiac-result]');

if (zpResultPage && zpResultAltLocation) {
	zpResultAltLocation.append(zpResultPage);
}

/* Disable Submit button until form is filled */
zpSubmit.setAttribute( 'disabled', true );

/* Autocomplete city field from GeoNames webservice */
const autoCompletejs = new autoComplete({
	data: {
		src: async function() {
			if (cityIn.value.length < 2) {
				return;
			} else {
				const token = zp_strings.u;
				const query = cityIn.value;// User search query
				const lang = zp_strings.lang;

				// Fetch External Data Source
				const source = await fetch(`https://ba-secure.geonames.net/searchJSON?name_startsWith=${query}&featureClass=P&style=full&maxRows=20&username=${token}&lang=${lang}`);

				const data = await source.json();
				var arr = [];
				/* Hide the geonames error message, if any, in case it is a 2nd try */
				zpRemoveError();
				/* check for GeoNames exceptions */
				if ( data.status !== undefined ) {			
					/* show new error */
					zpShowError( 'ERROR ' + data.status.value + ' - ' + data.status.message );
				} else {

					// Grab only the geonames fields that i need 
					for (var i = 0; i<data.geonames.length; i++) {
					  arr[i] = {
					  			name: data.geonames[i].name + ', ' + ( data.geonames[i].adminName1 ? data.geonames[i].adminName1 + ', ' : '' ) + data.geonames[i].countryName,
					  			lat: data.geonames[i].lat,
					  			lng: data.geonames[i].lng,
					  			zone: data.geonames[i].timezone.timeZoneId
					  		}
					}

				}

				// Return Fetched data
				return arr;

			}
		},
		key: ['name'],
		cache: false,
	},
	selector: "#placein",
	threshold: 1,// Minimum characters length before engine starts rendering results
	searchEngine: "loose",// Search Engine Type/Mode default strict
	maxResults: 20,
	resultsList: {
		render: true,
		container: function(source) {
		      source.setAttribute("id", "autoComplete_results_list");
		},
		destination: cityIn,
		position: "afterend",
		element: "ul",
	},
	resultItem: {
	    content: function(data, source) {
	      source.innerHTML = data.match;
	    },
	    element: "li",
	},
	onSelection: function(feedback) {
		// Clear Input			
		cityIn.value = '';

		// Change placeholder with the selected value
		cityIn.setAttribute( 'placeholder', feedback.selection.value.name );

		/* Update values for hidden inputs for timezone ID and birthplace coordinates */
		document.getElementById( 'place' ).value = feedback.selection.value.name;
		document.getElementById( 'geo_timezone_id' ).value = feedback.selection.value.zone;
		document.getElementById( 'zp_lat_decimal' ).value = feedback.selection.value.lat;
		document.getElementById( 'zp_long_decimal' ).value = feedback.selection.value.lng;

		zpGetOffset();
	},
});

/**
 * Ajax request to get time offset
 */
function zpGetOffset() {
	const form = (Array.from(new FormData(zpForm), e => e.map(encodeURIComponent).join('=')).join('&')) + '&action=zp_tz_offset';
	const xhr = new XMLHttpRequest();
	xhr.open( 'POST', zp_strings.ajaxurl );
	xhr.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
	xhr.responseType = 'json';
		
	xhr.onload = function() {

		if (xhr.status === 200 && xhr.response) {
			if ( xhr.response.error ) {

				/* remove previous errors if any */
				zpRemoveError();
					
				/* show new error */
				zpShowError( xhr.response.error );

			} else {

				/* if not null, blank, nor false, but 0 is okay  */
				if ( null !== xhr.response.offset_geo && '' !== xhr.response.offset_geo && 'false' != xhr.response.offset_geo) {

					/* remove previous errors if any */
					zpRemoveError();
								
					/* Display offset. */
					document.getElementById( 'zp-offset-wrap' ).style.display = 'block';
					document.getElementById( 'zp_offset_geo' ).value = xhr.response.offset_geo;
					document.getElementById( 'zp-form-tip' ).style.display = 'block';

					/* Enable submit button */
					zpSubmit.removeAttribute( 'disabled' );

				}

			}

		}
	};

	xhr.send( form );
}

/* Fetch birth report upon clicking submit */

zpSubmit.addEventListener( 'click', function( e ) {
	e.preventDefault();
	const form = Array.from(new FormData(zpForm), e => e.map(encodeURIComponent).join('=')).join('&');
	const xhr = new XMLHttpRequest();
	xhr.open( 'POST', zp_strings.ajaxurl );
	xhr.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
	xhr.responseType = 'json';
	xhr.onload = function() {
		if (xhr.status === 200 && xhr.response) {
			if ( xhr.response.error ) {

				/* remove previous errors if any */
				zpRemoveError();
							
				/* show new error */
				zpShowError( xhr.response.error );

			} else {

				/* if neither null, blank, nor false */
				var zpReport = xhr.response.report.trim();
				if ( zpReport && 'false' != zpReport ) {
					var content = document.getElementById( 'zp-report-content' ),
						wrap = document.getElementById( 'zp-report-wrap' );

					/* remove previous errors if any */
					zpRemoveError();

					/* Display report. */
					wrap.style.display = 'block'; 
					content.insertAdjacentHTML( 'afterbegin', xhr.response.report );
					document.getElementById( 'zp-form-wrap' ).style.display = 'none';
					document.querySelector('[data-zodiac-result-class]').classList.add("zodiac-result-shown");

					/* Insert the chart image. */
					switch ( zp_strings.draw ) {
						case 'top':

							/* Show image at top */
							document.querySelector( '.zp-report-header-table-wrapper' ).insertAdjacentHTML( 'beforebegin', xhr.response.image );
						break;
						case 'bottom':

							/* show image at end of report */
							content.insertAdjacentHTML( 'beforeend', xhr.response.image );
						break;
					}

					/* Scroll to top of report */
					window.scrollTo({ top: wrap.offsetTop, behavior: 'smooth' });// @test on safari

				}

			}

		}
	};

	xhr.send( form );
});

// Redo the Offset if date or time is changed.

zpForm.addEventListener( 'change', redoOffset );

function redoOffset( e ) {
	// Get offset after unknown_time checkbox is checked after notice of missing time
	if ( e.target.id === 'unknown_time' ) {

		if ( e.target.checked ) {
			// Only do ajax (get offset) if (partial) required fields are entered.
			if ( zpFieldsFilled() ) {
				zpGetOffset();
			}
		}

	} else {

		// Redo the Offset if date or time is changed.

		var selects = ['month', 'day', 'year', 'hour', 'minute'];

		// If the changed element doesn't have the right selector, bail
		if ( ! selects.includes( e.target.id ) ) return;

		var changed = ! e.target.options[e.target.selectedIndex].defaultSelected;
		if ( changed ) {

			// Only do ajax (get offset) if (partial) required fields are entered.
			if ( zpFieldsFilled() ) {
				zpGetOffset();
			}
		}
	}
}

/**
 * Check that the fields required to get offset are entered.
 */
function zpFieldsFilled() {
	var ids = ['geo_timezone_id','zp_long_decimal','zp_lat_decimal','place','minute','hour','year','day','month'];

	for ( var i of ids ) {

		var el = document.getElementById( i );

		if ( null === el ) {
			return false;
		}

        if ( el.value.length === 0 || ! el.value.trim() ) {

        	// if minute or hour are blank, pass if unknown time is checked
        	if ( 'minute' === i || 'hour' === i ) {
        		if ( document.getElementById( 'unknown_time' ).checked ) {
        			continue;
        		}
        	}

        	return false;
        }
	}
	return true;
}

function zpRemoveError() {
	var el = document.querySelector( '.ui-state-error' );
	if ( el !== null ) { el.parentNode.removeChild( el ); }
}

function zpShowError( msg ) {
	var span = document.createElement( 'span' );
	span.setAttribute( 'class', 'ui-state-error' );
	span.textContent = msg;
	var container = document.getElementById( 'zp-submit-wrap' );
	container.parentNode.insertBefore(span, container);
}
